import { put, takeLatest, call } from 'redux-saga/effects'
import { getAccountManager } from '@/core/apiModules/accountManager'
import * as accountManagerModule from '../modules/accountManager'
import { errorHandler } from '@/core/helpers/errorHelpers'

export function* fetchAccountManagerSaga({ meta }) {
  try {
    const response = yield call(getAccountManager, meta.companyId)
    yield put(accountManagerModule.fetchAccountManagerSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(accountManagerModule.fetchAccountManagerError(error))
  }
}

export default function* watchAccountManagerSaga() {
  yield takeLatest(accountManagerModule.FETCH_ACCOUNT_MANAGER, fetchAccountManagerSaga)
}
